import React from "react";
import { Link } from "react-router-dom";
import "./Admin.css";

const AdminLayout = ({ children }) => {
  return (
    <div className="admin-layout">
      {/* Admin Sidebar */}
      <nav className="admin-sidebar">
        <ul>
          <li><Link to="/admin">داشبورد</Link></li>
          <li><Link to="/admin/posts/new">ساخت پست جدید</Link></li>
          <li><Link to="/admin/comments">مدیریت نظرات</Link></li>
          <li><Link to="/admin/newspaper">روزنامه</Link></li>
        </ul>
      </nav>

      {/* Main Content Area */}
      <div className="admin-content">
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
